export { default } from './CompareIndustry';
